import { type MutationOptions, useMutation } from 'react-query'

import agent from 'agent'
import useAuth from 'hooks/use-auth'
import { failureFlagsMutationKeys } from 'queries/failure-flags/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

function protectFailureFlagApp([endpoint, params]: ReturnType<
  typeof failureFlagsMutationKeys.postAppsProtect
>) {
  return async () => {
    const endpointWithParams = getEndpointWithParams(endpoint, params)

    await agent.post(endpointWithParams)
  }
}

export const usePostFailureFlagsAppsProtect = (
  appName: string,
  options?: Omit<MutationOptions, 'mutationKey' | 'mutationFn'>
) => {
  const { currentTeamId: teamId } = useAuth()

  const queryParams = {
    appName,
    teamId
  }

  const mutationKey = failureFlagsMutationKeys.postAppsProtect(queryParams)

  return useMutation({
    ...options,
    mutationKey,
    mutationFn: protectFailureFlagApp(mutationKey)
  })
}
